/*
 * @Author: 80351408 vito.zeng@oppo.com
 * @Date: 2023-10-12 17:41:30
 * @LastEditors: 80351408 vito.zeng@oppo.com
 * @LastEditTime: 2023-10-13 11:13:12
 * @FilePath: \sns-user-frontend\src\hooks\windowState.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ref } from "vue";

export const windowFocused = ref(true);

export const onFocus = () => {
  windowFocused.value = true;
};

export const onBlur = () => {
  windowFocused.value = false;
};
